import React from 'react';
import Icon from '../../../components/AppIcon';

const EmergencyBanner = () => {
  const handleCallEmergency = () => {
    window.location.href = 'tel:+639171234567';
  };

  const handleReportIssue = () => {
    // This can be connected to a reporting system or modal
    alert('Report Issue functionality - Connect to your reporting system');
  };

  return (
    <section className="w-full bg-gradient-to-r from-red-500 via-orange-500 to-orange-400 py-2 md:py-3">
      <div className="max-w-[1400px] mx-auto px-2 md:px-4 lg:px-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-2 md:gap-3">
          {/* Left Section - Emergency Info */}
          <div className="flex items-center gap-1.5 md:gap-2">
            <div className="w-7 h-7 md:w-9 md:h-9 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
              <Icon name="AlertTriangle" size={16} color="#FFFFFF" />
            </div>
            <div>
              <h3 className="text-xs md:text-base font-bold text-white mb-0.5">
                Emergency Assistance
              </h3>
              <p className="text-[9px] md:text-xs text-white/90">
                Available 24/7 for all registered travelers
              </p>
            </div>
          </div>

          {/* Right Section - Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center gap-1.5 w-full md:w-auto">
            <button
              onClick={handleCallEmergency}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-white rounded-lg font-semibold text-red-600 hover:bg-white/95 transition-all duration-300 shadow-lg hover:shadow-xl w-full sm:w-auto justify-center text-xs"
            >
              <Icon name="Phone" size={12} color="#DC2626" />
              <span className="text-xs md:text-sm">+63 917 123 4567</span>
            </button>
            <button
              onClick={handleReportIssue}
              className="flex items-center gap-1 px-3 py-1.5 bg-white/10 backdrop-blur-sm border-2 border-white/30 rounded-lg font-medium text-white hover:bg-white/20 transition-all duration-300 w-full sm:w-auto justify-center text-xs"
            >
              <Icon name="Clock" size={12} color="#FFFFFF" />
              <span className="text-xs">Report Issue</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmergencyBanner;